import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  dataDelete: {
    isOpenPUDelete: false,
    contentPUDelete: "",
    id: "",
  },
  dataEdit: {
    isOpenPUEdit: false,
    contentEdit: "",
  },
};
const PopUpSlice = createSlice({
  name: "popup",
  initialState,
  reducers: {
    setOpenPUDelete: (state, action) => {
      state.dataDelete.isOpenPUDelete = action.payload.stateOpen;
      state.dataDelete.contentPUDelete = action.payload.content;
      state.dataDelete.id = action.payload.id;
    },
    setStatePUEdit: (state, action) => {
      state.dataEdit.isOpenPUEdit = action.payload.stateOpen;
      state.dataEdit.contentEdit = action.payload.contentEdit;
    },
  },
});
export default PopUpSlice;
export const { setOpenPUDelete, setStatePUEdit } = PopUpSlice.actions;
